/**
 * Puts United States and United Kingdom first, then remaining countries A–Z by name.
 * Works with objects that have countryName and/or countryCode (API shape).
 */
export function sortCountriesForDropdown(countries) {
  if (!Array.isArray(countries) || countries.length === 0) {
    return [];
  }

  const name = (c) => (c.countryName || "").trim().toLowerCase();
  const code = (c) => (c.countryCode || "").trim().toUpperCase();

  const isUS = (c) => code(c) === "US" || name(c) === "united states";
  const isUK = (c) =>
    code(c) === "GB" ||
    code(c) === "UK" ||
    name(c) === "united kingdom";

  const rest = [...countries];
  const top = [];

  const take = (predicate) => {
    const i = rest.findIndex(predicate);
    if (i !== -1) {
      top.push(rest.splice(i, 1)[0]);
    }
  };

  take(isUS);
  take(isUK);

  rest.sort((a, b) =>
    (a.countryName || "").localeCompare(b.countryName || "", undefined, {
      sensitivity: "base",
    })
  );

  return [...top, ...rest];
}
